module.exports = __webpack_public_path__ + "9fca2b76bd1f13f24e0c778a3e73ad9d.png";